import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

import { loadSession, getDeveloperDetails } from 'public/authentication.js';
import { biActionLinkButton } from 'public/biModule.js';
import { local } from 'wix-storage';

function changeButtonPostLogin(id) {
	try{
	$w(`#${id}`).onClick(() => {
		wixLocation.to('https://dev.wix.com/dc3/my-apps?referralInfo=devwix_lp_'+id)
	})
	}catch (e) {
		debugger;
	}
}

function goToDocs(id) {
	$w(`#${id}`).link = 'https://dev.wix.com/api/rest/getting-started/overview?referralInfo=devwix_lp_'+id;
	$w(`#${id}`).label = 'Learn More';
}

function goToRevShareDoc(id) {
	$w(`#${id}`).link = 'https://dev.wix.com/api/rest/getting-started/overview?referralInfo=devwix_lp_'+id;
	$w(`#${id}`).label = 'Read our Docs';
}

$w.onReady(function () {
	let formFactor = wixWindow.formFactor;
// $w('#exploreCTA').onClick( (event) => {
// 	biActionLinkButton({ button_name: 'explore_appmarket' });
// })

	if (formFactor === 'Mobile') {
		goToDocs('startNowBtn');
		goToDocs('startNowBtn2');
		goToDocs('buildAppButtton');
		goToDocs('monetizeAppButton');
		goToDocs('monetizeAppButtonCopy');
		goToDocs('exposeAppButton');
		goToRevShareDoc('exposeAppButton2');
	} else {
		// getDeveloperDetails().then(validUser => {
		// console.log(validUser)
		changeButtonPostLogin('startNowBtn');
		changeButtonPostLogin('startNowBtn2')
		changeButtonPostLogin('buildAppButtton');
		changeButtonPostLogin('monetizeAppButton');
		// changeButtonPostLogin('monetizeAppButtonCopy');
		// changeButtonPostLogin('exposeAppButton');
		changeButtonPostLogin('exposeAppButton2');

		// }).catch(valid => console.log('is valid::', valid));
	}
});

export function box2_mouseIn(event) {
	$w('#box3').show();
	$w('#box2').hide(); //Add your code for this event here: 
}
export function box3_mouseOut(event) {
	$w('#box2').show();
	$w('#box3').hide(); //Add your code for this event here: 
}

export function text19_mouseIn(event) {
	$w('#text20').show();
	$w('#text19').hide(); //Add your code for this event here: 
}

export function text20_mouseOut(event) {
	$w('#text19').show();
	$w('#text20').hide(); //Add your code for this event here: 
}

export function text22_mouseIn(event) {
	$w('#text21').show();
	$w('#text22').hide(); //Add your code for this event here: 
}

export function text21_mouseOut(event) {
	$w('#text22').show();
	$w('#text21').hide(); //Add your code for this event here: 
}

export function MonitizeBox_mouseIn(event) {
	$w('#MonitiszeHoverBox').show();
	$w('#MonitizeBox').hide(); //Add your code for this event here: 
}

export function MonitiszeHoverBox_mouseOut(event) {
	$w('#MonitiszeHoverBox').hide();
	$w('#MonitizeBox').show(); //Add your code for this event here: 
}

export const getStarted_onClick = (event) => {
	biActionLinkButton({ button_name: 'get_started' });
}

export const exploreResources_onClick = (event) => {
	biActionLinkButton({ button_name: 'explore_resources' });
}

export const checkItOut_onClick = (event) => {
	biActionLinkButton({ button_name: 'check_out_wix_engineering' });
}
